/* eslint-disable jsx-a11y/no-autofocus */
import React, { FC } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import { IconButton, ThemeProvider, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { GLOBALMESSAGES } from "../../constants/messages";
import appTheme from "../../assets/theme/theme";

interface ConfirmationDialogProps {
  open: boolean;
  title: string;
  message: string;
  onClose: (confirmed: boolean) => void;
  onDiscard?: () => void;
}

const ConfirmationDialog: FC<ConfirmationDialogProps> = ({
  open,
  title,
  message,
  onClose,
  onDiscard,
}) => {
  const handleClose = (confirmed: boolean) => {
    onClose(confirmed);
  };

  const handleDiscard = () => {
    onDiscard();
  };

  return (
    <ThemeProvider theme={appTheme}>
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason === GLOBALMESSAGES.BACKDROP) {
          return;
        }
        if (onDiscard) {
          handleDiscard();
        } else {
          handleClose(false);
        }
      }}
      aria-labelledby="responsive-dialog-title"
      PaperProps={{
    className: "confirmation-dialog-paper"
  }}
    >
      <DialogTitle id="responsive-dialog-title">{title}</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={() => {
          if (onDiscard) {
            handleDiscard();
          } else {
            handleClose(false);
          }
        }}
        className="dialog-close-button"
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers>
        <Typography gutterBottom>{message}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => handleClose(false)} color="light" variant="contained" size="small">
          No
        </Button>
        <Button autoFocus onClick={() => handleClose(true)} variant="contained" size="small">
          Yes
        </Button>
      </DialogActions>
    </Dialog>
    </ThemeProvider>
  );
};

export default ConfirmationDialog;
